import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { QuillModule } from 'ngx-quill';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { TreoNavigationModule } from 'tsui/@treo';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule as MatAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { Overlay } from '@angular/cdk/overlay';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatStepperModule } from '@angular/material/stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { AddDispositionsGroupComponent } from './components/add-dispositions-group/add-dispositions-group.component';
import { AddDispositionsComponent } from './components/add-dispositions/add-dispositions.component';
import { DispositionsTableComponent } from './components/dispositions-table/dispositions-table.component';
import { MergeProjectService } from './services/merge-project.service';
import { UpdateProjectStatusService } from './services/update-project-status.service';
import { DealsWithSamePropertiesComponent } from './components/deals-with-same-properties/deals-with-same-properties.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { TsTableComponent } from 'tsui/lib/ts-table';

@NgModule({
  declarations: [
    AddDispositionsComponent,
    AddDispositionsGroupComponent,
    DispositionsTableComponent,
    DealsWithSamePropertiesComponent,
  ],
  exports: [AddDispositionsComponent, AddDispositionsGroupComponent, DispositionsTableComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    CdkStepperModule,
    MatStepperModule,
    QuillModule.forRoot(),
    MatMomentDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    TreoAutogrowModule,
    CurrencyMaskModule,
    TreoFindByKeyPipeModule,
    TreoNavigationModule,
    DragDropModule,
    MatAutocompleteModule,
    MatChipsModule,
    SharedModule,
    MatDialogModule,
    RouterModule,
    PipesModule,
    DigitOnlyModule,
    TsTableComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
    MergeProjectService,
    UpdateProjectStatusService,
  ],
})
export class ProjectsSharedModule {}
